<template>
  <main class="l-container"
    :class="{uWhite: $route.name==='kodateDetail',
    no_padding: no_padding
   }"
   >
    <div
      :class="{
        bg_ground_white: bg_ground_white,
        bg_ground_gray: bg_ground_gray,
        max_width: max_width,
        kodate_detail: $route.name === 'kodateDetail' ? true : false
      }"
      class="l-container__inner">
      <slot name="body"></slot>
    </div>
    <div class="l-container__breadArea">
      <common-breadcrumb
        v-if="breadHeading"
        :heading="breadHeading"
        :breadcrumbType="$route.name === 'kodateDetail' ? 'detail' : 'default'"
      />
      <common-breadcrumb
        v-else-if="pref_name && prop_name"
        :pref_name="pref_name"
        :prop_name="prop_name"
        :breadcrumbType="$route.name === 'kodateDetail' ? 'detail' : 'default'"
      />
    </div>
  </main>
</template>

<script>
import MixinAPI from '@/plugins/mixin-api';
import IsMobile from '@/plugins/isMobile';
import CommonBreadcrumb from '@/components/parts/CommonBreadcrumb';
import CommonButton from '@/components/parts/button/CommonButton';
import CommonSelect from '@/components/parts/select/CommonSelect';

export default {
  name: 'CommonLayoutTemplate',
  mixins: [MixinAPI, IsMobile],
  props: [
    'title',
    'isBread',
    'breadHeading',
    'propData',
    'pref_name',
    'prop_name',
    'bg_ground_white',
    'max_width',
    'no_padding',
    'bg_ground_gray',
  ],
  components: {
    CommonBreadcrumb,
    CommonButton,
    CommonSelect,
  },
  data() {
    return {
      isMobile: false,
      isTablet: false,
    };
  },
  computed: {
    isPropData() {
      return this.propData;
    },
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
// brake points 768px(tablet)/639px(sp)
@charset "UTF-8";
.l-container {
  padding: 30px 20px 0;
  flex: 1 0 auto;
  background: #fafafa;
  overflow-x: hidden;

  &.no_padding {
    padding: 30px 0;

    .l-container__inner {
      max-width: 980px;
    }
  }

  &__inner {
    width: 100%;
    max-width: 980px;
    padding: 33px 64px 50px;
    margin: 0 auto;
    border-radius: 20px;
    border: 1px solid #ccc;
    background: #fff;

    &.kodate_detail {
      padding: 30px;
    }
  }
  &__breadArea {
    max-width: 980px;
    margin: 0 auto;

    .c-bread {
      width: 100%;
      padding: 20px 10px;
      margin: 0;
    }
  }
}
.c-heading {
  font-family: "メイリオ", "Meiryo", sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  text-align: center;
}

@media screen and (max-width: 999px) {
  .uWhite {
    background-color: #FFF;
  }
  .l-container {
    &.no_padding {
      padding: 0;

      .l-container__inner.max_width {
        max-width: none;
      }
    }
  }
  .l-container__inner.bg_ground_white {
    padding: 0;
    border-radius: 0;
    border: 0;
    background: #fff;
  }
  .l-container__inner.max_width {
    max-width: 520px;
    margin: 0 auto;
  }
}


@media screen and (max-width: 767px) {
  .uWhite {
    background-color: #FFF;
  }
  .l-container {
    &__inner {
      padding: 33px 20px 50px;
      margin-bottom: 20px;

      &.bg_ground_gray {
        padding: 0;
        border: 0;
        background: #fafafa;
      }
    }
  }
}

</style>
